import { isMobile } from '../../utilities/user-agent';
import {resetPriceRange, resetDeliveryTime, resetSelectedFilter} from './pues';

export class SearchFilter {
  init() {
    const priceSlider = document.getElementById('price-range');
    const priceFilterMsg = document.querySelector('.price-filter-msg');
    let rangeMin = 0;
    let rangeMax = 0;
    let rangeInputs: any;
    let rangeBar: HTMLElement;
    let minPriceInputText: HTMLInputElement;
    let maxPriceInputText: HTMLInputElement;
    let min: number;
    let max: number;
    let minPriceInputTextMin: string;
    let maxPriceInputTextMax: string;

    if (priceSlider) {
      rangeInputs = priceSlider.querySelectorAll('#minPrice, #maxPrice');
      rangeBar = priceSlider.querySelector('.trackBar') as HTMLElement;

      rangeMin = parseInt((rangeInputs[0] as HTMLInputElement)?.value);
      rangeMax = parseInt((rangeInputs[1] as HTMLInputElement)?.value);

      min = parseInt((rangeInputs[0] as HTMLInputElement)?.min);
      max = parseInt((rangeInputs[1] as HTMLInputElement)?.max);

      minPriceInputText = document.getElementById('filter-slider-range.price-0') as HTMLInputElement;
      minPriceInputTextMin = minPriceInputText?.min;
      maxPriceInputText = document.getElementById('filter-slider-range.price-1') as HTMLInputElement;
      maxPriceInputTextMax = maxPriceInputText?.max;

      rangeInputs[0]?.addEventListener('change', changeMinRange);
      rangeInputs[1]?.addEventListener('change', changeMaxRange);

      rangeInputs[0]?.addEventListener('input', changeMinRange);
      rangeInputs[1]?.addEventListener('input', changeMaxRange);

      minPriceInputText?.addEventListener('keyup', validateMinPriceFilterByKeyUp);
      minPriceInputText?.addEventListener('change', validateMinPriceFilterByChange);

      maxPriceInputText?.addEventListener('keyup', validateMaxPriceFilterByKeyUp);
      maxPriceInputText?.addEventListener('change', validateMaxPriceFilterByChange);

      const isIE11 = document.body.parentElement.classList.contains('no-webp');

      if (isIE11) {
        const sliderWidth = priceSlider.clientWidth;

        const mousemove = (e: any) => {
          const itemOffset = priceSlider.getBoundingClientRect().left - 1;
          const xpos = e.screenX - itemOffset;
          const calc = sliderWidth / 100;
          const percentPos = xpos / calc;
          const percent1 = ((rangeMin - min) / (max - min)) * 100;
          const percent2 = ((rangeMax - min) / (max - min)) * 100;
          const arr = [percent1, percent2];
          const closest = arr.reduce((prev: number, curr: number): number => {
            return (Math.abs(curr - percentPos) < Math.abs(prev - percentPos) ? 1 : 0);
          });

          if (closest === 0) {
            rangeInputs[1].removeAttribute('style');
            (rangeInputs[0] as HTMLInputElement).style.zIndex = '9';
          }
          if (closest === 1) {
            rangeInputs[0].removeAttribute('style');
            (rangeInputs[1] as HTMLInputElement).style.zIndex = '9';
          }
        }

        priceSlider.addEventListener('mousemove', mousemove);
      }

      updateRangeBar();
    }

    function changeMinRange() {
      rangeMin = parseInt((rangeInputs[0] as HTMLInputElement).value);
      rangeMax = parseInt((rangeInputs[1] as HTMLInputElement).value);

      if (rangeMax <= rangeMin && rangeMax < parseInt(maxPriceInputText.max)) {
        rangeMax = rangeMin + 1;
        (rangeInputs[1] as HTMLInputElement).value = (rangeMin + 1).toString();
      }
      if(rangeMin === parseInt(maxPriceInputText.max)) {
        minPriceInputText.value = (parseInt(maxPriceInputText.max) - 1).toString();
      } else {
        minPriceInputText.value = (rangeInputs[0] as HTMLInputElement).value;
      }

      maxPriceInputText.value = rangeMax.toString();

      if(!priceFilterMsg.classList.contains('hidden')) {
        priceFilterMsg.classList.add('hidden');
      }
      updateRangeBar();
    }

    function changeMaxRange() {
      rangeMin = parseInt((rangeInputs[0] as HTMLInputElement).value);
      rangeMax = parseInt((rangeInputs[1] as HTMLInputElement).value);

      if (rangeMin >= rangeMax && rangeMin > 0) {
        rangeMin = rangeMax - 1;
        (rangeInputs[0] as HTMLInputElement).value = (rangeMax - 1).toString();
      }
      if(rangeMax === 0) {
        maxPriceInputText.value = '1';
      } else {
        maxPriceInputText.value = (rangeInputs[1] as HTMLInputElement).value;
      }

      minPriceInputText.value = rangeMin.toString();

      if(!priceFilterMsg.classList.contains('hidden')) {
        priceFilterMsg.classList.add('hidden');
      }
      updateRangeBar();
    }

    function validateMinPriceFilterByKeyUp() {
      if ((minPriceInputText.value !== ''
          && maxPriceInputText.value !== '')
          && (parseInt(minPriceInputText.value) < parseInt(maxPriceInputText.value))) {

        (rangeInputs[0] as HTMLInputElement).value = minPriceInputText.value;
        rangeMin = parseInt(minPriceInputText.value);

        if(!priceFilterMsg.classList.contains('hidden')) {
          priceFilterMsg.classList.add('hidden');
        }

        updateRangeBar();

      } else {
        priceFilterMsg.classList.remove('hidden');
      }
    }

    function validateMinPriceFilterByChange() {
      if ((minPriceInputText.value !== ''
          && maxPriceInputText.value !== '')
          && (parseInt(minPriceInputText.value) >= parseInt(maxPriceInputText.value))) {

        minPriceInputText.value = minPriceInputTextMin;
        maxPriceInputText.value = maxPriceInputTextMax;

        (rangeInputs[0] as HTMLInputElement).value = minPriceInputTextMin;
        rangeMin = parseInt(minPriceInputTextMin);

        (rangeInputs[1] as HTMLInputElement).value = maxPriceInputTextMax;
        rangeMax = parseInt(maxPriceInputTextMax);

        if(!priceFilterMsg.classList.contains('hidden')) {
          priceFilterMsg.classList.add('hidden');
        }

        updateRangeBar();
      }
    }

    function validateMaxPriceFilterByKeyUp() {
      if ((maxPriceInputText.value !== ''
          && minPriceInputText.value !== '')
          && (parseInt(maxPriceInputText.value) > parseInt(minPriceInputText.value))) {

        (rangeInputs[1] as HTMLInputElement).value = maxPriceInputText.value;
        rangeMax = parseInt(maxPriceInputText.value);

        if(!priceFilterMsg.classList.contains('hidden')) {
          priceFilterMsg.classList.add('hidden');
        }

        updateRangeBar();
      } else {
        priceFilterMsg.classList.remove('hidden');
      }
    }

    function validateMaxPriceFilterByChange() {
      if ((maxPriceInputText.value !== ''
          && minPriceInputText.value !== '')
          && (parseInt(maxPriceInputText.value) <= parseInt(minPriceInputText.value))) {

        minPriceInputText.value = minPriceInputTextMin;
        maxPriceInputText.value = maxPriceInputTextMax;

        (rangeInputs[0] as HTMLInputElement).value = minPriceInputTextMin;
        rangeMin = parseInt(minPriceInputTextMin);

        (rangeInputs[1] as HTMLInputElement).value = maxPriceInputTextMax;
        rangeMax = parseInt(maxPriceInputTextMax);

        if(!priceFilterMsg.classList.contains('hidden')) {
          priceFilterMsg.classList.add('hidden');
        }

        updateRangeBar();
      }
    }

    function updateRangeBar() {
      const start = ((rangeMin - min) / (max - min)) * 100;
      const end = ((rangeMax - min) / (max - min)) * 100;
      rangeBar.style.background = `linear-gradient(to right, #d6d6d6 ${start}% , #065066 ${start}% , #065066 ${end}%, #d6d6d6 ${end}%)`;
    }
  }

  activeFilter() {
    const activeFilters = document.querySelectorAll('.active-filter-container .filter-tag');
    const filterWrapper = document.querySelector('.filter-form-wrapper');
    activeFilters.forEach((filter: HTMLElement) => {
      filter.querySelector('.remove-tag').addEventListener('click', () => {
        if (filterWrapper) {
          filter.classList.add('loading');
          const filterValue = filter.dataset.value;
          if (filterValue === 'range.price') {
            resetPriceRange();
          } else if (filterValue === 'range.deliveryTime') {
            resetDeliveryTime();
          } else {
            const activeFilter = filterWrapper.querySelector('.js-toggle-filter-check input[value="' + filterValue + '"][data-filter-id="' + filter.dataset.id + '"]') as HTMLInputElement;
            resetSelectedFilter(activeFilter);
            if (isMobile.any()) {
              const mobileFilterSubmit = document.querySelector('.mobile-filter-submit') as HTMLButtonElement;
              mobileFilterSubmit && mobileFilterSubmit.click();
            }
          }
        }
      });
    });
  }
}
